(ns app.domain.transfer-of-permit.model)

(def approval-field-id
  :transfer-of-permit-approved)

(def removal-choice-field-id
  :transfer-of-permit-removal)

(def removal-choice-remove
  "remove")

(def removal-choice-remain
  "remain")
